<template>
  <div :class="classObj" class="app-wrapper">
    <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
    <sidebar class="sidebar-container" />
    <div class="main-container">
      <app-main />
      <div class="logout-container">
        <span>{{userName}}</span>
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link">
            <img src="../assets/images/login/logout.png" alt="">
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="loginOut">退出登录</el-dropdown-item>
            <el-dropdown-item command='modifyRefundPass' v-if="userRole == 1">修改管理密码</el-dropdown-item>
            <el-dropdown-item command='modifyPass'>修改密码</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { Sidebar, AppMain } from './components';
import ResizeMixin from './mixin/ResizeHandler';
import { logout } from '@/api/login';

export default {
  name: 'Layout',
  components: {
    Sidebar,
    AppMain,
  },
  mixins: [ResizeMixin],
  data() {
    return {
      userName: '',
    };
  },
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    device() {
      return this.$store.state.app.device;
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile',
      };
    },
  },
  methods: {
    handleCommand(command) {
      if (command === "loginOut") {
        this.doLogOut();
      } else if (command === "modifyPass") {
        this.goModifyPwd();
      } else {
        this.goModifyRefundPwd();
      }
    },
    goModifyRefundPwd() {
      this.$router.push({ path: '/modifyRefundPwd' });
    },
    doLogOut() {
      logout({
        userName: JSON.parse(window.localStorage.getItem('LOGIN_INFO')).userName,
        sessionId: JSON.parse(window.localStorage.getItem('LOGIN_INFO')).sessionId,
      }).then((res) => {
        if (res.data.error_code === 0) {
          window.localStorage.clear();
          this.$router.push({ path: '/login' });
        }
      });
    },
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false });
    },
    goModifyPwd() {
      this.$router.push({ path: '/modifyPwd' });
    },
  },
  created() {
    if (JSON.parse(window.localStorage.getItem('LOGIN_INFO'))) {
      const { userRole } = JSON.parse(window.localStorage.getItem('LOGIN_INFO'));
      this.userRole = userRole;
      // userRole = 1为店长
      if (userRole === 1) {
        this.userName = JSON.parse(window.localStorage.getItem('LOGIN_INFO')).merchantName;
      } else {
        this.userName = JSON.parse(window.localStorage.getItem('LOGIN_INFO')).userName;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
  @import "~@/styles/mixin.scss";
  @import "~@/styles/variables.scss";
  .main-container {
    .logout-container {
      position: absolute;
      top: 30px;
      right: 50px;
      display: flex;
      align-items: center;
      img {
        cursor: pointer;
        padding-left: 20px;
      }
    }
  }
  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    // width: 100%;
    min-width: 1362px;
    overflow: auto;
    &.mobile.openSidebar{
      position: fixed;
      top: 0;
    }
  }
  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }

  .fixed-header {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
    width: calc(100% - #{$sideBarWidth});
    transition: width 0.28s;
  }

  .hideSidebar .fixed-header {
    width: calc(100% - 54px)
  }

  .mobile .fixed-header {
    width: 100%;
  }
</style>
